import { render } from "./WhatsAppModalChatNameModal.vue?vue&type=template&id=72098402"
import script from "./WhatsAppModalChatNameModal.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalChatNameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__